/* ============================================================
   FIX DE SIMBOLO DE MONEDA
   ============================================================ */

var CURRENCY_SYMBOL_FIXES = {
  GTQ: { symbol: 'Q', pattern: /\$(?=\s?\d)/g }
  // PYG: { symbol: '₲', pattern: /\$(?=\s?\d)/g },
};

var CURRENCY_FIX_ROOTS = ['#rebuy-cart', '.rebuy-widget'];

function currencyFixConfig(){
  var code = null;
  try {
    if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.currency === 'function') {
      code = Rebuy.SmartCart.currency();
    }
  } catch (e) {}
  if (!code && window.Shopify && Shopify.currency) code = Shopify.currency.active;
  return code ? CURRENCY_SYMBOL_FIXES[code] || null : null;
}

function fixCurrencySymbols(scope){
  var config = currencyFixConfig();
  if (!config) return;

  requestAnimationFrame(function(){
    var roots = scope
      ? [scope]
      : Array.prototype.concat.apply([], CURRENCY_FIX_ROOTS.map(function(selector){
          return Array.prototype.slice.call(document.querySelectorAll(selector));
        }));

    roots.forEach(function(root){
      if (!root) return;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (!node.nodeValue) continue;
        config.pattern.lastIndex = 0;
        if (!config.pattern.test(node.nodeValue)) continue;
        config.pattern.lastIndex = 0;
        node.nodeValue = node.nodeValue.replace(config.pattern, config.symbol);
      }
    });
  });
}





if (window.location.href.indexOf("gift-quitapenas-charms") > -1){
    window.location.replace("https://mariasbag.com/");
};


/* Script Load Cart */

$('.open-cart-rebuy').click(function() {
  cartLoad();
});

function cartLoad(){
  if (typeof Rebuy === 'undefined' || typeof Rebuy.SmartCart === 'undefined' || typeof Rebuy.SmartCart.show !== 'function') {
    RebuyPreload();
  } else {
    Rebuy.SmartCart.show();
  };
};

function RebuyPreload(){
  $('body').addClass('show-cart-preload');
};

function cartReady(){
  if ($('body').hasClass('show-cart-preload')) {
    setTimeout(function() {
      $('body').removeClass('show-cart-preload');
      Rebuy.SmartCart.show();
    }, 1000);
  };
};


/* Script GWP */

function renderContainer(){
  $(".rebuy-cart__flyout-body .rebuy-cart__flyout-content").prepend(
    `<section class="message-gwp">
      <div class="message-gwp__content">
        <div class="message-gwp__container">
          <div class="message-gwp__imagen">
            <img src="">
          </div>
         
        <div class="view-more">
    
        </div>
        
      </div>
    </section>`
  );
};


function getTags(total, ArrayProducts){
  
    var tags = ArrayProducts;
    var AllTags = ''; 
    
    for (var i = 0; i < tags.length; i++) {
        var item = tags[i]; 
        var products = (item && item.product && item.product.tags) ? item.product.tags : '';
        AllTags += products + ', ';
        if (i === tags.length - 1) { 
            AllTags = AllTags.slice(0, -2);
            // console.log("AllTags:", AllTags);
            if (AllTags.includes('COLLECTION: ESENCIA MARIAS')) {
              var collection = 'ESENCIA MARIAS';
              // console.log("Colección detectada:", collection);
              addGiftPurchase(total, ArrayProducts, collection);
            } else {
              var collection = 'SEGUNDA GENERATION';
              // console.log("Colección detectada:", collection);
              addGiftPurchase(total, ArrayProducts, collection);
            };
        };
    };

  
};



function addGiftPurchase(total,ArrayProducts,collection){

  var $total_price = total;
  var $array_products = ArrayProducts;
  var $collection = collection;

  function $product_offer(productId){return productId.product_id === 9338722320677;};var $validation_product = $array_products.find($product_offer);

  if ($validation_product !== undefined) {
    if($total_price <= 0){
      jQuery.post('/cart/update.js', { updates: { 48786151342373: 0 } });
    } else {
      var $qty_product = $validation_product.quantity;
      if($qty_product > 1){
        if($collection == 'ESENCIA MARIAS'){
          jQuery.post('/cart/update.js', { updates: { 48786151342373: 1 } });
        } else {
          jQuery.post('/cart/update.js', { updates: { 48786151342373: 0 } });
        };
      } else {
        if($collection == 'ESENCIA MARIAS'){
          // console.log('No se hacen cambios.')
        } else {
          jQuery.post('/cart/update.js', { updates: { 48786151342373: 0 } });
        };
      };
    };
  };

  if($total_price > 0){
    
    if ($validation_product === undefined){
      if($collection == 'ESENCIA MARIAS'){
        var dataProduct = {
          "id": 48786151342373,
          "quantity": 1
        };
      };
              
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: dataProduct,
        dataType: 'json',
        success: function() { 
          // console.log('Gift: Agregado');
        }
      });
    };
    
  };
  
};





/* Script Events Rebuy */

document.addEventListener('rebuy:smartcart.ready', function(event){
  var total = event.detail.smartcart.cart.total_price;
  var products = event.detail.smartcart.cart.items;
  fixCurrencySymbols();
  cartReady();
  renderContainer();
  try { getTags(total,products); } catch(e){ console.warn('getTags:', e); }
});

document.addEventListener('rebuy:cart.change', function(event){
  var total = event.detail.cart.cart.total_price;
  var products = event.detail.cart.cart.items;
  var qty = event.detail.cart.cart.item_count;
  var containerGift = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .message-gwp');
  
  $('.open-cart-rebuy span[data-js-cart-count]').text(qty);

  fixCurrencySymbols(); 

  if (containerGift.length > 0) {
    Promise.resolve().then(() => getTags(total, products));
  }; 
});


/* Widgets de Rebuy (You may also like)
   Envolvemos formatMoney en la instancia Vue del widget, para que
   el simbolo correcto quede en el render y sobreviva los repintados. */

var patchedWidgets = new WeakSet();

function patchWidgetMoney(event){
  var widget = event && event.detail ? event.detail.widget : null;
  var vue = widget && widget.View ? widget.View.vue : null;
  if (!vue || typeof vue.formatMoney !== 'function') return;
  if (patchedWidgets.has(vue)) return;

  var nativeFormat = vue.formatMoney.bind(vue);

  vue.formatMoney = function(){
    var output = nativeFormat.apply(null, arguments);
    var config = currencyFixConfig();
    if (!config || typeof output !== 'string') return output;
    config.pattern.lastIndex = 0;
    return output.replace(config.pattern, config.symbol);
  };

  patchedWidgets.add(vue);

  if (typeof vue.$forceUpdate === 'function') vue.$forceUpdate();
}

document.addEventListener('rebuy.init', patchWidgetMoney);
document.addEventListener('rebuy.beforeReady', patchWidgetMoney);
document.addEventListener('rebuy.ready', patchWidgetMoney);
document.addEventListener('rebuy.productsChange', patchWidgetMoney);
document.addEventListener('rebuy.refresh', patchWidgetMoney);



/* Eventos GWP: Mostrar Información */

$(document).on('click', '.message-gwp #view-more.no-active', function() { 
  $(this).text('Hidden');
  $(this).addClass('active');
  $(this).removeClass('no-active');
  $('.rebuy-cart__flyout-content .message-gwp .view-more').slideDown();
});


$(document).on('click', '.message-gwp #view-more.active', function() { 
  $(this).text('What are Quitapenas?');
  $(this).addClass('no-active');
  $(this).removeClass('active');
  $('.rebuy-cart__flyout-content .message-gwp .view-more').slideUp();
});
